export default __webpack_public_path__ + "static/media/MiniChopper.ec4d1bb6.png";